import Vue from 'vue';

Vue.component('shell-app-reimbursement-index', () =>
    import(/* webpackChunkName: 'shell-app-reimbursement-datatable' */ './shell-app-reimbursement-index.vue'),
);
